<nz-modal [(nzVisible)]="isVisible" [nzTitle]="'POC Details'" [nzWidth]="900" (nzOnCancel)="handleCancel()" [nzFooter]="footerTpl" >

  <ng-container *nzModalContent>

    <nz-table #basicTable [nzData]="poc_details" [nzBordered]="false" [nzSize]="'small'" [nzShowPagination]="'false'">
      <thead>
        <tr>
          <!-- <th>Client</th> -->
          <th>Contact Person</th>
          <th>Phone Number</th>
          <th>vendor</th>
          <th>Created by</th>
          <th *ngIf="showActions">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let poc of poc_details">
          <td>
            <nz-tag [nzColor]="'#87d068'">{{poc?.contact_person}}</nz-tag>
          </td>
          <td>{{poc?.country_code}} {{poc?.phone_number}}</td>
          <td>{{poc?.vendor}}</td>

          <td>{{poc?.created_by}}</td>
          <td *ngIf="showActions">
            <button nz-button nzType="default" nzSize="small" style="margin-left: 8px;"
            nz-tooltip [nzTooltipTitle]="'Edit'"  nzTooltipPlacement="top"
            (click)="editPOC(poc)"><nz-icon nzType="edit" nzTheme="outline" /></button>

            <button
              class="custom-popconfirm"
              nz-popconfirm
              [nzPopconfirmOverlayClassName]="'custom-popconfirm-popover'"
              [nzPopconfirmTitle]="popconfirmTpl"
              nzPopconfirmPlacement="bottom"
              nz-button nzDanger nzSize="small" style="margin-left: 8px;"
              (nzOnConfirm)="deletePOC(poc)"
              nz-tooltip [nzTooltipTitle]="'Delete'" nzTooltipPlacement="top"
            >
              <nz-icon nzType="delete" nzTheme="outline" />
            </button>
          <!-- Custom Popconfirm Template for Delete Confirmation -->
          <ng-template #popconfirmTpl let-popconfirm="popconfirm">
            <div class="custom-popconfirm-header">
              <span class="custom-popconfirm-title">Confirm Deletion</span>
            </div>
            <div class="custom-popconfirm-icon-area">
              <span style="display: flex; justify-content: center; margin: 18px 0 8px 0;">
                <nz-icon nzType="warning-fill" nzTheme="fill" style="font-size: 32px; color: #ff6c6c;"></nz-icon>
              </span>
            </div>
            <div class="custom-popconfirm-message description">
              Are you sure you want to delete this item?<br />
              <span style="color:#888; font-size:14px;">This action cannot be undone.</span>
            </div>
            <!-- <div class="custom-popconfirm-footer" style="display: flex; justify-content: flex-end; gap: 8px; margin-top: 24px;">
              <button nz-button nzType="default" class="custom-delete-modal__cancel" (click)="$event.stopPropagation(); popconfirm?.nzCancel.emit()">Cancel</button>
              <button nz-button nzType="primary" nzDanger class="custom-delete-modal__ok" (click)="$event.stopPropagation(); popconfirm?.nzConfirm.emit()">
                <nz-icon nzType="delete" nzTheme="outline" style="margin-right: 4px;"></nz-icon>OK
              </button>
            </div> -->
          </ng-template>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </ng-container>

  <ng-template #footerTpl>
    <div >

      <button nz-button nzType="primary" (click)="handleOk()" > OK</button>
    </div>
  </ng-template>
</nz-modal>
